import {
  ADD_MENU_ACTIVE_CLASS_REQUEST,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD_REQUEST,
  FORGET_PASSWORD_SUCCESS,
  GET_USER_FOUND,
  GET_USER_NOT_FOUND,
  GET_USER_REQUEST,
  LOGOUT_SUCCESS,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_STATUS,
  RESET_PASSWORD_SUCCESS,
  UPDATE_FORGET_PASSWORD_STATUS,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILED,
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED,
  FORGET_VALIDATE_OTP_REQUEST,
  FORGET_VALIDATE_OTP_SUCCESS,
  FORGET_VALIDATE_OTP_FAILED,
  CLEAR_AUTH_RESPONSE,
  ACCOUNT_VERIFICATION_REQUEST,
  ACCOUNT_VERIFICATION_SUCCESS,
  ACCOUNT_VERIFICATION_FAILED,
  EMAIL_VERIFICATION_REQUEST,
  EMAIL_VERIFICATION_FAILED,
  EMAIL_VERIFICATION_SUCCESS,
  REGISTER_EXISTING_USER_REQUEST,
  REGISTER_EXISTING_USER_SUCCESS,
  REGISTER_EXISTING_USER_FAILED,
  GET_EDITOR_SUCCESS,
  GET_EDITOR_REQUEST,
  GET_EDITOR_FAILED,
  REMOVE_EDITOR_REQUEST,
  REMOVE_EDITOR_SUCCESS,
  REMOVE_EDITOR_FAILED,
} from "../Actions/AuthActions";

const LoginInitialState = {
  loading: false,
  emailVerified: false,
  otpVerified: false,
  accountVerified: false,
  user: {},
  currentAction: "INIT",
  forgetPass: "",
  resetPass: "",
  token: "",
  changePass: "",
  redirect: "",
  isMenuActive: false,
  success: false,
  message: "",
  editorList: [],
  totalCount: 0,
  add_editor: false,
};

export const AuthReducer = (state = LoginInitialState, action) => {
  switch (action.type) {
    case ADD_MENU_ACTIVE_CLASS_REQUEST:
      return {
        ...state,
        isMenuActive: !state.isMenuActive,
      };

    case GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
        currentAction: action.type,
      };

    case GET_USER_FOUND:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("userData", JSON.stringify(action.payload));
      return {
        ...state,
        user: action.payload,
        loading: false,
        currentAction: action.type,
        token: action.payload.token,
      };
    case GET_USER_NOT_FOUND:
      return { ...state, loading: false };

    case VALIDATE_OTP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VALIDATE_OTP_SUCCESS:
      return {
        ...state,
        otpVerified: true,
        loading: false,
      };
    case VALIDATE_OTP_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FORGET_VALIDATE_OTP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FORGET_VALIDATE_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.success,
      };
    case FORGET_VALIDATE_OTP_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };

    case REGISTER_USER_REQUEST:
      return {
        ...state,
        loading: true,
        currentAction: action.type,
        add_editor: false,
      };

    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        currentAction: action.type,
        loading: false,
        success: action.payload.success,
        add_editor: true,
      };

    case REGISTER_USER_FAILED:
      return {
        ...state,
        user: "",
        loading: false,
        success: false,
        add_editor: false,
      };

    case LOGOUT_SUCCESS:
      localStorage.clear();
      return {
        ...state,
        user: {},
        token: "",
        currentAction: action.type,
      };
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        redirect: "failed",
        success: false,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        redirect: "success",
        changePass: action.payload,
      };
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        redirect: "failed",
        changePass: "",
      };
    case FORGET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        forgetPass: action.payload,
        loading: false,
      };
    case FORGET_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        forgetPass: action.payload,
      };
    case UPDATE_FORGET_PASSWORD_STATUS:
      return {
        ...state,
        loading: false,
        forgetPass: null,
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload == true ? "passChanged" : "",
      };
    case RESET_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case RESET_PASSWORD_STATUS:
      return {
        ...state,
        loading: false,
        redirect: null,
      };

    case ACCOUNT_VERIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        redirect: "failed",
      };
    case ACCOUNT_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        accountVerified: action.payload,
        success: true,
        redirect: "success",
        message: action.payload,
      };
    case ACCOUNT_VERIFICATION_FAILED:
      return {
        ...state,
        message: action.payload,
        loading: false,
        accountVerified: false,
        success: false,
        redirect: "failed",
      };

    case EMAIL_VERIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        redirect: "failed",
      };
    case EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        accountVerified: action.payload,
        success: true,
        redirect: "success",
        message: action.payload,
      };
    case EMAIL_VERIFICATION_FAILED:
      return {
        ...state,
        message: action.payload,
        loading: false,
        accountVerified: false,
        success: false,
        redirect: "failed",
      };
    case CLEAR_AUTH_RESPONSE:
      return {
        loading: false,
        success: false,
        message: "",
      };
    case REGISTER_EXISTING_USER_REQUEST:
      return {
        ...state,
        loading: true,
        currentAction: action.type,
        add_editor: false,
      };
    case REGISTER_EXISTING_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        add_editor: true,
      };
    case REGISTER_EXISTING_USER_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        add_editor: false,
      };
    case GET_EDITOR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_EDITOR_SUCCESS:
      return {
        ...state,
        loading: false,
        editorList: action?.payload?.editors_obj,
        totalCount: action?.payload?.count,
      };
    case GET_EDITOR_FAILED:
      return {
        ...state,
        loading: false,
      };

    case REMOVE_EDITOR_REQUEST:
      return {
        ...state,
        loading: true,
        add_editor: false,
      };
    case REMOVE_EDITOR_SUCCESS:
      return {
        ...state,
        loading: false,
        editorList: state?.editorList?.filter(
          (item) => item?.id !== action?.payload?.Id
        ),
        add_editor: true,
      };
    case REMOVE_EDITOR_FAILED:
      return {
        ...state,
        loading: false,
        add_editor: false,
      };
    default:
      return state;
  }
};
